import Utils from '../../../../utils/utils';

export default Utils;



//////////////////
// WEBPACK FOOTER
// ./node_modules/framework7/components/swiper/swiper-class/utils/utils.js
// module id = null
// module chunks = 